import React, {
  useLayoutEffect,
} from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useStaffListApiService } from '../../services';
import { useGlobalState } from '../../contexts/global-state';
import { showError } from '../../helpers/ui';

export default ({ schoolId }) => {
  const {
    selectedSchool,
    setSelectedSchool,
    managedSchools } = useGlobalState();
  const {
    getStaffListBySchoolAsync
  } = useStaffListApiService();

  const navigate = useNavigate();

  if (!schoolId) {
    showError("No school was specified.");
    navigate(-1);
  }

  useLayoutEffect(() => {
    const fetchData = async () => {
      try {
        if (!selectedSchool || selectedSchool.schoolId !== parseInt(schoolId)) {
          if (managedSchools.length === 0) return;
          const school = managedSchools.find(s => s.schoolId === parseInt(schoolId));
          if (typeof (school) === 'undefined') {
            navigate(-1);
            return;
          }
          if (school) {
            const r = await getStaffListBySchoolAsync(schoolId);
            school.staffList = r.data;
            setSelectedSchool(school);
          }
        }
      } catch (error) {
        showError(error.message);
        navigate(-1);
      }
    };
    fetchData();
  }, [
    selectedSchool,
    setSelectedSchool,
    managedSchools,
    schoolId,
    getStaffListBySchoolAsync,
    navigate,
  ]);

  return <Outlet />;
}